import Footer from '../../footer/Footer';
import Navbar from '../../navbar/Navbar';
import AboutLeftTab from '../../About/AboutLeftTab';

const ITDeptWorkshopMLPythonJan2026 = () => {
    const workshopImages = [
        // "1.png",
        "2.png",
        "3.png",
        "4.png",
        "5.png",
    ];

    return (
        <div>
            <Navbar />

            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <AboutLeftTab />

                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="col-lg-12 ps-lg-4">
                                <div className="how-to-apply">
                                    <h2>
                                        IT Dept Workshop: A Three-day Workshop on “Machine Learning with Python”
                                    </h2>

                                    <div className="py-2">
                                        <p>
    A Three-day Workshop on <strong>“Machine Learning with Python”</strong> was conducted for 3rd-year students.
    The primary objective of learning machine learning with Python is to equip them with practical skills to
    solve complex, data-driven engineering problems across various domains like materials science,
    predictive maintenance, and autonomous systems.
</p>


                                      
                                    </div>

                                    <div className="css-script-ads"></div>

                                    <div className="spotlight-group">
                                        <div className="row">
                                            {workshopImages.map((img, index) => (
                                                <div key={index} className="col-md-6 mb-3 mb-lg-4">
                                                    <a
                                                        className="spotlight"
                                                        href={`https://admin.swec.ac.in/assetsswec/img/ML-Workshop-Jan-2026/${img}`}
                                                    >
                                                        <img
                                                            src={`https://admin.swec.ac.in/assetsswec/img/ML-Workshop-Jan-2026/${img}`}
                                                            alt={`IT Dept Machine Learning with Python Workshop Image ${index + 1}`}
                                                            className="img-responsive center-block"
                                                        />
                                                    </a>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default ITDeptWorkshopMLPythonJan2026;
